import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { 
  LayoutDashboard, List, LogOut, ArrowLeft, ExternalLink, 
  Clock, Building2, ChevronLeft, ChevronRight, Users, BarChart2, Plus
} from 'lucide-react';
import { publicaciones } from '../data/mockPublicaciones';
import '../demo-professional.css';

const OFERTAS_PER_PAGE = 3;

export default function DemoPublicacionDetalle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [mostrarTodasOfertas, setMostrarTodasOfertas] = useState(false);
  const [paginaOfertas, setPaginaOfertas] = useState(1);

  const publicacion = publicaciones.find(p => p.id === parseInt(id));

  const handleLogout = () => {
    localStorage.removeItem('demo_authenticated');
    navigate('/propuesta/demo');
  };

  if (!publicacion) {
    return (
      <div className="min-h-screen" style={{ background: '#f8fafc' }} className="flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-2" style={{ color: '#0f172a' }}>Publicación no encontrada</h2>
          <button
            onClick={() => navigate('/propuesta/demo/publicaciones')}
            className="font-medium"
            style={{ color: '#1e40af' }}
          >
            ← Volver al listado
          </button>
        </div>
      </div>
    );
  }

  const totalPaginasOfertas = Math.ceil(publicacion.revendedores.length / OFERTAS_PER_PAGE);
  const startIndexOfertas = (paginaOfertas - 1) * OFERTAS_PER_PAGE;
  const endIndexOfertas = startIndexOfertas + OFERTAS_PER_PAGE;
  const ofertasActuales = publicacion.revendedores.slice(startIndexOfertas, endIndexOfertas);

  return (
    <div className="min-h-screen" style={{ background: '#f8fafc' }}>
      {/* Header */}
      <header className="demo-header sticky top-0 z-10">
        <div className="px-4 sm:px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3 sm:gap-4">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%)' }}>
              <Building2 className="text-white" size={20} />
            </div>
            <div>
              <h1 className="text-base sm:text-lg font-bold" style={{ fontFamily: 'Outfit, sans-serif', color: '#f8fafc' }}>
                Sistema de Tasación
              </h1>
              <p className="text-xs" style={{ color: '#94a3b8' }}>Vladimir & Aerocar</p>
            </div>
          </div>
          <div className="flex items-center gap-1">
            <button
              onClick={() => navigate('/propuesta')}
              className="flex items-center gap-1.5 px-3 py-2 text-sm rounded-lg transition hover:bg-white/5"
              style={{ color: '#94a3b8' }}
              data-testid="demo-back-to-propuesta"
              title="Volver a la propuesta"
            >
              <ArrowLeft size={16} />
              <span className="hidden sm:inline">Propuesta</span>
            </button>
            <button
              onClick={handleLogout}
              className="flex items-center gap-2 px-3 py-2 text-sm rounded-lg transition"
              style={{ color: '#94a3b8' }}
              onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.05)'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
            >
              <LogOut size={16} />
              <span className="hidden sm:inline">Salir</span>
            </button>
          </div>
        </div>
      </header>

      {/* Navigation */}
      <nav style={{ background: 'white', borderBottom: '1px solid #e2e8f0' }}>
        <div className="px-4 sm:px-6 py-2 flex items-center gap-1 sm:gap-2 overflow-x-auto">
          {[
            { id: 'dashboard',    label: 'Dashboard',    icon: <LayoutDashboard size={15} />, path: '/propuesta/demo/dashboard' },
            { id: 'publicaciones', label: 'Publicaciones', icon: <List size={15} />, path: '/propuesta/demo/publicaciones', active: true },
            { id: 'revendedores',  label: 'Revendedores',  icon: <Users size={15} />, path: '/propuesta/demo/revendedores' },
            { id: 'reportes',      label: 'Reportes',      icon: <BarChart2 size={15} />, path: '/propuesta/demo/reportes' },
          ].map(tab => (
            <button key={tab.id} onClick={() => navigate(tab.path)}
              className={`flex items-center gap-1.5 px-3 py-2 text-sm font-medium rounded-lg whitespace-nowrap transition ${tab.active ? 'text-orange-600 bg-orange-50' : 'text-gray-500 hover:text-gray-800 hover:bg-gray-50'}`}>
              {tab.icon}<span>{tab.label}</span>
            </button>
          ))}
          <button onClick={() => navigate('/propuesta/demo/nueva')}
            className="flex items-center gap-1.5 px-4 py-2 text-sm font-semibold text-white rounded-lg ml-auto whitespace-nowrap"
            style={{ background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)' }}>
            <Plus size={15} /><span>Nueva</span>
          </button>
        </div>
      </nav>

      {/* Content */}
      <main className="px-4 sm:px-6 py-6 sm:py-8 max-w-6xl mx-auto">
        {/* Botón Volver */}
        <button
          onClick={() => navigate('/propuesta/demo/publicaciones')}
          className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg transition mb-6"
          style={{ color: '#475569', border: '1px solid #e2e8f0', background: 'white' }}
          onMouseEnter={(e) => e.currentTarget.style.background = '#f8fafc'}
          onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
        >
          <ArrowLeft size={16} />
          <span>Volver al listado</span>
        </button>

        {/* Header con datos del vehículo */}
        <div className="rounded-xl p-6 mb-6" style={{ background: 'linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%)', color: 'white' }}>
          <div className="flex items-start justify-between mb-4">
            <div>
              <h1 className="text-2xl sm:text-3xl font-bold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
                {publicacion.marca} {publicacion.modelo}
              </h1>
              <div className="flex flex-wrap items-center gap-3 text-sm">
                <span style={{ background: 'rgba(255,255,255,0.2)', padding: '4px 12px', borderRadius: '9999px', fontWeight: 500 }}>
                  {publicacion.version || 'N/A'}
                </span>
                <span style={{ background: 'rgba(255,255,255,0.2)', padding: '4px 12px', borderRadius: '9999px', fontWeight: 500 }}>
                  Año {publicacion.año}
                </span>
                <span style={{ background: 'rgba(255,255,255,0.2)', padding: '4px 12px', borderRadius: '9999px', fontWeight: 500, fontFamily: 'monospace' }}>
                  {publicacion.patente}
                </span>
                {publicacion.unicoDueño && (
                  <span style={{ background: '#059669', padding: '4px 12px', borderRadius: '9999px', fontWeight: 500 }}>
                    ✓ Único dueño
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-sm">
            <div>
              <div style={{ opacity: 0.7 }} className="mb-1">Motor</div>
              <div className="font-bold">{publicacion.motor}</div>
            </div>
            <div>
              <div style={{ opacity: 0.7 }} className="mb-1">Kilometraje</div>
              <div className="font-bold">{publicacion.kilometraje.toLocaleString()} km</div>
            </div>
            <div>
              <div style={{ opacity: 0.7 }} className="mb-1">Combustible</div>
              <div className="font-bold">{publicacion.combustible}</div>
            </div>
            <div>
              <div style={{ opacity: 0.7 }} className="mb-1">Transmisión</div>
              <div className="font-bold">{publicacion.transmision}</div>
            </div>
          </div>
        </div>

        {/* TASACIONES - DISEÑO PROFESIONAL */}
        <div className="demo-card overflow-hidden mb-6">
          <div className="px-6 py-4" style={{ borderBottom: '1px solid #e2e8f0', background: '#f8fafc' }}>
            <h2 className="text-xl font-bold" style={{ fontFamily: 'Outfit, sans-serif', color: '#0f172a' }}>
              Tasaciones
            </h2>
            <p className="text-sm mt-1" style={{ color: '#64748b' }}>Información de múltiples fuentes</p>
          </div>

          <div className="p-6 space-y-4">
            {/* Grid de 2 columnas para tasaciones */}
            <div className="grid md:grid-cols-2 gap-4">
              {/* AUTODATA */}
              <div className="demo-tasacion-card demo-tasacion-autodata">
                <div className="flex items-center gap-3 mb-4">
                  <div className="text-xs font-bold uppercase tracking-wider" style={{ color: '#64748b' }}>AUTODATA</div>
                  <div className="text-xs" style={{ color: '#94a3b8' }}>API Oficial</div>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <div className="text-xs mb-1" style={{ color: '#64748b' }}>Precio de Toma</div>
                    <div className="text-2xl font-bold" style={{ fontFamily: 'Outfit, sans-serif', color: '#0f172a' }}>
                      ${publicacion.autodata.toma.toLocaleString()}
                    </div>
                  </div>
                  <div>
                    <div className="text-xs mb-1" style={{ color: '#64748b' }}>Precio de Venta</div>
                    <div className="text-2xl font-bold" style={{ fontFamily: 'Outfit, sans-serif', color: '#0f172a' }}>
                      ${publicacion.autodata.venta.toLocaleString()}
                    </div>
                  </div>
                </div>
              </div>

              {/* EXPECTATIVA CLIENTE */}
              <div className="demo-tasacion-card demo-tasacion-cliente">
                <div className="flex items-center gap-3 mb-4">
                  <div className="text-xs font-bold uppercase tracking-wider" style={{ color: '#64748b' }}>EXPECTATIVA DEL CLIENTE</div>
                </div>
                <div className="text-xs mb-2" style={{ color: '#64748b' }}>Valoración inicial</div>
                <div className="text-3xl font-bold" style={{ fontFamily: 'Outfit, sans-serif', color: '#0f172a' }}>
                  ${publicacion.expectativaCliente.toLocaleString()}
                </div>
              </div>

              {/* VALORACIÓN VENDEDOR */}
              <div className="demo-tasacion-card demo-tasacion-vendedor">
                <div className="flex items-center gap-3 mb-4">
                  <div className="text-xs font-bold uppercase tracking-wider" style={{ color: '#64748b' }}>VALORACIÓN DEL VENDEDOR</div>
                </div>
                <div className="text-xs mb-2" style={{ color: '#64748b' }}>Tasación interna</div>
                <div className="text-3xl font-bold" style={{ fontFamily: 'Outfit, sans-serif', color: '#0f172a' }}>
                  ${publicacion.valoracionVendedor.toLocaleString()}
                </div>
              </div>

              {/* MERCADO LIBRE */}
              {publicacion.mercadoLibre ? (
                <div className="demo-tasacion-card demo-tasacion-ml">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="text-xs font-bold uppercase tracking-wider" style={{ color: '#64748b' }}>MERCADO LIBRE</div>
                    <div className="text-xs" style={{ color: '#94a3b8' }}>Scraping de precios</div>
                  </div>
                  <div className="space-y-3">
                    <div>
                      <div className="text-xs mb-1" style={{ color: '#64748b' }}>Promedio</div>
                      <div className="text-2xl font-bold" style={{ fontFamily: 'Outfit, sans-serif', color: '#0f172a' }}>
                        ${publicacion.mercadoLibre.promedio.toLocaleString()}
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-2 text-sm">
                      <a
                        href={publicacion.mercadoLibre.urlMenor}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-between p-2 rounded-lg transition"
                        style={{ background: '#f8fafc', border: '1px solid #e2e8f0' }}
                        onMouseEnter={(e) => e.currentTarget.style.background = '#f1f5f9'}
                        onMouseLeave={(e) => e.currentTarget.style.background = '#f8fafc'}
                      >
                        <div>
                          <div className="text-xs" style={{ color: '#64748b' }}>↓ Menor</div>
                          <div className="font-bold" style={{ color: '#0f172a' }}>${publicacion.mercadoLibre.menor.toLocaleString()}</div>
                        </div>
                        <ExternalLink size={14} style={{ color: '#64748b' }} />
                      </a>
                      <a
                        href={publicacion.mercadoLibre.urlMayor}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-between p-2 rounded-lg transition"
                        style={{ background: '#f8fafc', border: '1px solid #e2e8f0' }}
                        onMouseEnter={(e) => e.currentTarget.style.background = '#f1f5f9'}
                        onMouseLeave={(e) => e.currentTarget.style.background = '#f8fafc'}
                      >
                        <div>
                          <div className="text-xs" style={{ color: '#64748b' }}>↑ Mayor</div>
                          <div className="font-bold" style={{ color: '#0f172a' }}>${publicacion.mercadoLibre.mayor.toLocaleString()}</div>
                        </div>
                        <ExternalLink size={14} style={{ color: '#64748b' }} />
                      </a>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="demo-tasacion-card" style={{ background: '#f8fafc' }}>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="text-xs font-bold uppercase tracking-wider" style={{ color: '#64748b' }}>MERCADO LIBRE</div>
                  </div>
                  <div className="text-center py-6">
                    <Clock size={24} style={{ color: '#cbd5e1' }} className="mx-auto mb-2" />
                    <p className="text-sm" style={{ color: '#64748b' }}>Procesando scraping...</p>
                  </div>
                </div>
              )}

              {/* GERENCIA */}
              {publicacion.gerencia ? (
                <div className="demo-tasacion-card demo-tasacion-gerencia">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="text-xs font-bold uppercase tracking-wider" style={{ color: '#64748b' }}>GERENCIA</div>
                    <div className="text-xs" style={{ color: '#94a3b8' }}>Valoración de dueños</div>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <div className="text-xs mb-1" style={{ color: '#64748b' }}>Alex 1</div>
                      <div className="text-2xl font-bold" style={{ fontFamily: 'Outfit, sans-serif', color: '#0f172a' }}>
                        ${publicacion.gerencia.alex1.toLocaleString()}
                      </div>
                    </div>
                    <div>
                      <div className="text-xs mb-1" style={{ color: '#64748b' }}>Ale 2</div>
                      <div className="text-2xl font-bold" style={{ fontFamily: 'Outfit, sans-serif', color: '#0f172a' }}>
                        ${publicacion.gerencia.ale2.toLocaleString()}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="demo-tasacion-card" style={{ background: '#f8fafc' }}>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="text-xs font-bold uppercase tracking-wider" style={{ color: '#64748b' }}>GERENCIA</div>
                  </div>
                  <div className="text-center py-6">
                    <Clock size={24} style={{ color: '#cbd5e1' }} className="mx-auto mb-2" />
                    <p className="text-sm" style={{ color: '#64748b' }}>Esperando valoración vía WhatsApp</p>
                  </div>
                </div>
              )}

              {/* REVENDEDORES - Full width */}
              <div className="md:col-span-2 demo-tasacion-card demo-tasacion-revendedores">
                <div className="flex items-center gap-3 mb-4">
                  <div className="text-xs font-bold uppercase tracking-wider" style={{ color: '#64748b' }}>REVENDEDORES</div>
                  <div className="text-xs" style={{ color: '#94a3b8' }}>{publicacion.revendedores.length} ofertas recibidas</div>
                </div>

                <div className="space-y-2">
                  {(mostrarTodasOfertas ? ofertasActuales : publicacion.revendedores.slice(0, 3)).map((rev, index) => (
                    <div key={index} className="flex items-center justify-between p-4 rounded-lg transition" style={{ background: '#f8fafc', border: '1px solid #e2e8f0' }}>
                      <div className="flex items-center gap-4">
                        <div className="text-xl">{index === 0 && '🥇'}{index === 1 && '🥈'}{index === 2 && '🥉'}</div>
                        <div>
                          <div className="text-sm font-bold" style={{ fontFamily: 'Outfit, sans-serif', color: '#0f172a' }}>
                            {rev.nombre}
                          </div>
                          <div className="text-lg font-bold" style={{ fontFamily: 'Outfit, sans-serif', color: '#1e40af' }}>
                            USD {rev.oferta.toLocaleString()}
                          </div>
                        </div>
                      </div>
                      <button className="demo-btn-primary px-4 py-2 text-sm rounded-lg">
                        Adjudicar
                      </button>
                    </div>
                  ))}
                </div>

                {publicacion.revendedores.length > 3 && (
                  <div className="mt-4">
                    {!mostrarTodasOfertas ? (
                      <button
                        onClick={() => setMostrarTodasOfertas(true)}
                        className="w-full py-2 text-sm font-medium rounded-lg transition"
                        style={{ color: '#1e40af', background: 'white', border: '1px solid #e2e8f0' }}
                      >
                        Ver todas las ofertas ({publicacion.revendedores.length})
                      </button>
                    ) : (
                      <>
                        {totalPaginasOfertas > 1 && (
                          <div className="flex items-center justify-center gap-2 mt-3">
                            <button
                              onClick={() => setPaginaOfertas(Math.max(1, paginaOfertas - 1))}
                              disabled={paginaOfertas === 1}
                              className="p-2 rounded-lg"
                              style={{ color: paginaOfertas === 1 ? '#cbd5e1' : '#1e40af' }}
                            >
                              <ChevronLeft size={18} />
                            </button>
                            <span className="text-sm" style={{ color: '#64748b' }}>
                              Página {paginaOfertas} de {totalPaginasOfertas}
                            </span>
                            <button
                              onClick={() => setPaginaOfertas(Math.min(totalPaginasOfertas, paginaOfertas + 1))}
                              disabled={paginaOfertas === totalPaginasOfertas}
                              className="p-2 rounded-lg"
                              style={{ color: paginaOfertas === totalPaginasOfertas ? '#cbd5e1' : '#1e40af' }}
                            >
                              <ChevronRight size={18} />
                            </button>
                          </div>
                        )}
                        <button
                          onClick={() => { setMostrarTodasOfertas(false); setPaginaOfertas(1); }}
                          className="w-full py-2 text-sm font-medium rounded-lg transition mt-2"
                          style={{ color: '#1e40af', background: 'white', border: '1px solid #e2e8f0' }}
                        >
                          Ocultar ofertas
                        </button>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Descripción */}
        <div className="demo-card p-6">
          <h3 className="text-lg font-bold mb-3" style={{ fontFamily: 'Outfit, sans-serif', color: '#0f172a' }}>
            Observaciones
          </h3>
          <p style={{ color: '#475569', lineHeight: '1.75' }}>{publicacion.descripcion}</p>
        </div>
      </main>
    </div>
  );
}
